import React, { useState } from "react";
import { Form, Input, Button, Typography, Alert } from "antd";
import "./../Login.css";
import { LoginOutlined } from "@ant-design/icons";
import { auth, firestore } from "../firebase";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./Context";
import { useAuditoria } from "../hooks/useAuditoria";
import { doc, getDoc } from "firebase/firestore";

const { Title } = Typography;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const { setToken, setCurrentUser } = useAuth();
  const { auditar, auditarLogin } = useAuditoria();

  const navigate = useNavigate();

  const onFinish = async () => {
    setLoading(true);
    setButtonDisabled(true);
    try {
      const userCredential = await auth.signInWithEmailAndPassword(
        email,
        password
      );
      const user = userCredential.user;
      const token = await user.getIdToken();
      
      // Obtener información de la sucursal del usuario
      let sucursalId = '';
      let rol = 'admin';
      
      try {
        // Intentar obtener info del usuario (como su sucursal) de la base de datos
        // Esto es un enfoque aproximado, ajusta según tu estructura de datos
        const userDocRef = doc(firestore, 'usuarios', user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const userData = userDoc.data();
          sucursalId = userData.sucursal || '';
          rol = userData.rol || 'admin';
        }
      } catch (err) {
        console.error("Error al obtener información del usuario:", err);
        // No detener el flujo por este error
      }
      
      // Establecer token y usuario en el contexto
      setToken(token);
      setCurrentUser(user);
      
      // Registrar el login en la auditoría
      // Nota: Esto podría fallar si aún no tenemos sucursal o token actualizado
      // por lo que lo hacemos de forma asíncrona y no esperamos
      setTimeout(() => {
        auditarLogin(rol)
          .then(() => {
            // Login registrado exitosamente
          })
          .catch(err => {
            console.error("Error al registrar login en auditoría:", err);
          });
      }, 1000);
      
      // Navegar a la página principal
      navigate("/sistema/bienvenida");
    } catch (error) {
      setLoading(false); // Ocultar loader después de iniciar sesión (ya sea éxito o fallo)
      setButtonDisabled(false);
      console.error("Error al iniciar sesión:", error.message);
      setErrorMessage("Credenciales incorrectas."); // Actualiza el mensaje de error
    }
  };

  return (
    // <AuthProvider>
    <div className="tbody">
      <div className="login-container">
        <div className="login-wrapper">
          <div className="login-content">
            <Title className="txt-center mb-5" level={2}>
              Iniciar sesión
            </Title>
            <br></br>
            <Form
              name="login-form"
              initialValues={{
                // remember: true,
                email: email,
                password: password,
              }}
              onFinish={onFinish}
            >
              <Form.Item
                label="Usuario"
                name="email"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa tu usuario.",
                  },
                ]}
              >
                <Input
                  maxLength={45}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                label="Contraseña"
                name="password"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                rules={[
                  {
                    required: true,
                    message: "Por favor ingresa tu contraseña.",
                  },
                ]}
              >
                <Input.Password
                  maxLength={20}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />
              </Form.Item>
              <Form.Item className="txt-center mt-5">
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<LoginOutlined />}
                  loading={loading}
                  disabled={buttonDisabled}
                  size="large"
                >
                  Ingresar
                </Button>
              </Form.Item>
            </Form>
          </div>
          {errorMessage && (
            <Alert
              message={errorMessage}
              type="error"
              showIcon
              className="custom-alert"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
